
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RepoIntegrationStatus',

  props: {
    active: {
      type: Boolean,
      required: true
    }
  }
})
